import React from 'react';

import type { IStarState } from '../../../models';

export const FilledStar = ({ className, dataTestId, key, onClick, onMouseEnter }: IStarState) => (
    <svg
        key={key}
        data-test-id={dataTestId}
        fill="none"
        height="32"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            className={className}
            d="M14.7513 4.67326C15.1832 3.51813 16.8171 3.51813 17.2491 4.67326L19.641 11.0702C19.8284 11.5713 20.2972 11.9119 20.8317 11.9353L27.6547 12.2334C28.8868 12.2872 29.3917 13.8412 28.4265 14.6089L23.0819 18.8606C22.6632 19.1936 22.4841 19.7447 22.6271 20.2603L24.4519 26.8415C24.7815 28.0299 23.4596 28.9903 22.4312 28.3096L16.7361 24.5404C16.2899 24.2451 15.7105 24.2451 15.2643 24.5404L9.56914 28.3096C8.54073 28.9903 7.21888 28.0299 7.54841 26.8415L9.37328 20.2603C9.51624 19.7447 9.33718 19.1936 8.91849 18.8606L3.57381 14.6089C2.60869 13.8412 3.11359 12.2872 4.34566 12.2334L11.1687 11.9353C11.7032 11.9119 12.1719 11.5713 12.3593 11.0702L14.7513 4.67326Z"
            fill="#F15045"
            stroke="#F15045"
        />
    </svg>
);
